import apiClient from "../../services/apiClient";

export async function fetchLoginUrlAPI() {
  // 로그인 URL을 받아오는 API
  const response = await apiClient.post("/api/v1/login/url");
  return response.data["login_url"]; // 응답 형식에 따라 조정
}

export async function verifyCodeAPI(data) {
  const response = await apiClient.post("/api/v1/login/verify", data);
  return response;
}

export async function fetchUserInfoAPI() {
  const response = await apiClient.get("/api/v1/user/me", { withAuth: true });
  return response.data; // 응답 형식에 따라 조정
}

export async function updateUserInfoAPI(data) {
  const response = await apiClient.put("/api/v1/user/me", data, {
    withAuth: true,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data; // 응답 형식에 따라 조정
}
